import { Injectable } from '@angular/core';
import { IdHelper } from 'apps/idl/src/helpers/idHelper';
import { IEntity } from 'apps/idl/src/model/entities/IEntity';
import { MetaEntityBuilderBase } from 'apps/idl/src/modules/dms/model/MetaEntityBuilderBase';
import { C_PREFIX_TOURNEE } from '../../../app/app.constants';

@Injectable()
export class MetaTourneeBuilder extends MetaEntityBuilderBase {

	//#region METHODS

	/** @override */
	public match(psDocumentId: string): boolean {
		return IdHelper.hasPrefixId(psDocumentId, C_PREFIX_TOURNEE);
	}

	/** @override */
	public getEntityContainerId(poEntity: IEntity): string {
		return this.isvcWorkspace.getWorkspaceIdFromDatabaseId(this.isvcWorkspace.getDefaultWorkspaceDatabaseId());
	}

	//#endregion

}
